<aura-landing-projection class="flex h-screen">
  <div main class="flex flex-col gap-4">
    <div class="mt-4">Vous n'êtes pas authorisé à acceder à cette ressource.</div>

    @switch (reason) {
      @case (notAuthorizedReason.NOT_ADMIN) {
        <div>
          <div class="font-semibold text-red">Vous n'êtes pas administrateur.</div>
          <button mat-button class="link" (click)="logOut()">Se déconnecter</button>
        </div>
      }
    }

    <div class="text-secondary text-md mt-8 font-medium">
      <button mat-button class="link" (click)="backHome()">Revenir vers la page d'acceuil</button>
    </div>
  </div>
</aura-landing-projection>
